export const removeEndSlash = (path: string): string => (path.endsWith('/') ? path.slice(0, -1) : path);
